import { Link } from "@tanstack/react-router";
import { Check } from "@phosphor-icons/react";
import { Card, Avatar, Button } from "@/components/ui";
import { Img } from "@/components/media/Img";
import type { Store } from "@/api/types";
import { formatCompact } from "@/lib/format";
import { RatingStars } from "./RatingStars";
import { useStoreFollowToggle } from "./useStoreFollowToggle";

export function StoreCard({ store }: { store: Store }) {
  const follow = useStoreFollowToggle(store);
  const following = store.isFollowing;
  return (
    <Card padded={false} className="overflow-hidden" data-testid="store-card">
      <Img imageKey={store.banner.key} alt={store.banner.alt} aspect="16/5" sizes="(min-width: 768px) 320px, 100vw" className="rounded-t-md" />
      <div className="px-4 pb-4">
        <div className="relative -mt-6 mb-2 flex items-end justify-between">
          <Avatar size="lg48" imageKey={store.avatar.key} alt={store.name} className="ring-3 ring-surface-2" />
          <Button size="sm" variant={following ? "secondary" : "ghost"} onClick={(event) => { event.preventDefault(); void follow.toggle(); }} disabled={follow.isPending}>{following ? "Following" : "Follow"}</Button>
        </div>
        <Link
          to="/store/$slug"
          params={{ slug: store.slug }}
          search={{ sort: "popular" }}
          className="block focus-visible:outline-2 focus-visible:outline-primary"
        >
          <h3 className="text-h5 text-text-primary">
            {store.name}
            {store.verified && (
              <span className="ml-2 inline-flex text-primary-text" role="img" aria-label="Verified">
                <Check className="size-4" aria-hidden="true" />
              </span>
            )}
          </h3>
          <p className="truncate text-small text-text-secondary">{store.tagline}</p>
          <div className="mt-2 flex items-center gap-1 text-caption text-text-secondary tnum"><RatingStars rating={store.rating} /><span>·</span><span>{formatCompact(store.productCount)} products</span><span>·</span><span>{formatCompact(store.followers)} followers</span></div>
        </Link>
      </div>
    </Card>
  );
}
